import {
  FRONTEND_LOG_API_BASE_PATH,
  FRONTEND_LOG_API_RESOURCES,
  FRONTEND_LOG_API_RESOURCE_PREFIXES,
  FRONTEND_LOG_ERROR_CODES,
  FRONTEND_LOG_ERROR_TYPES,
  FRONTEND_LOG_QUIET_REQUEST,
} from "../const/frontend-logs";
import type { FrontendErrorFields } from "../types/frontend-logs";

// Ephemeral correlation only: no account data, cookies or persistent storage.
export const browserSessionId =
  typeof globalThis.crypto?.randomUUID === "function"
    ? globalThis.crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export function getFrontendErrorFields(error: unknown): FrontendErrorFields {
  try {
    const value = error && typeof error === "object" ? (error as Record<string, unknown>) : {};
    const response =
      value.response && typeof value.response === "object" ? (value.response as Record<string, unknown>) : {};
    return {
      errorType:
        typeof value.name === "string" && FRONTEND_LOG_ERROR_TYPES.has(value.name) ? value.name : "UnknownError",
      ...(typeof value.code === "string" && FRONTEND_LOG_ERROR_CODES.has(value.code) ? { code: value.code } : {}),
      ...(typeof response.status === "number" &&
      Number.isInteger(response.status) &&
      response.status >= 100 &&
      response.status <= 599
        ? { status: response.status }
        : {}),
    };
  } catch {
    return { errorType: "UnknownError" };
  }
}

export function getFrontendApiResource(url: unknown): string {
  if (typeof url !== "string") return "unknown";
  try {
    const path = new URL(url, window.location.origin).pathname.replace(FRONTEND_LOG_API_BASE_PATH, "");
    const resource = path.split("/").filter(Boolean)[0];
    // Return allowlisted route labels only, never a URL, business value or query.
    if (resource && FRONTEND_LOG_API_RESOURCES.has(resource)) return resource;
    return (
      Object.entries(FRONTEND_LOG_API_RESOURCE_PREFIXES).find(([prefix]) => resource?.startsWith(prefix))?.[1] ??
      "other"
    );
  } catch {
    return "unknown";
  }
}

export function isQuietFrontendRequest(url: string | undefined): boolean {
  try {
    return FRONTEND_LOG_QUIET_REQUEST.test(new URL(url ?? "", window.location.origin).pathname);
  } catch {
    return false;
  }
}
